// Copyright aptihealth, inc. 2019 All Rights Reserved
import React from "react";
import Hr from "../../UI/Hr";
import Button from "../../UI/Button";
import { getAutomationDataAttr } from "../../../utils/automationUtils";

const ProfileDetailsCard = (props) => {
  return (
    <div
      className={`ProviderProfile__ProfileDetailsCard p-4 mb-3 mb-lg-4 ${
        props.noBoxShadow ? "no-box-shadow" : ""
      }`}
    >
      <div className="d-flex justify-content-between" data-public="true">
        <h1 className="fs-16 ml-2 mb-3 pb-1 tw:font-bold">{props.heading}</h1>
        <Button
          type="button"
          onClick={props.onclick}
          {...getAutomationDataAttr(props.testId ? `${props.testId}EditButton` : undefined)}
          className={`ProviderProfile__ProfileDetailsCard-controls cursor mr-2 fs-14 mb-3 tw:font-bold ${
            props.edit ? "d-none" : ""
          }`}
        >
          Edit
        </Button>
      </div>
      <Hr />
      {props.children}
    </div>
  );
};

export default ProfileDetailsCard;
